import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M2.75 7.8a2 2 0 0 1 .865-1.646L10 1.75l6.386 4.404A2 2 0 0 1 17.25 7.8v8.45a2 2 0 0 1-2 2H4.75a2 2 0 0 1-2-2V7.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M7.75 12.75a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1v5.5h-4.5v-5.5Z"
		})
	]
});
const ForwardRef = forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
